<template>
  <div>
    <!-- When Selection has entries, render a multi-select dropdown -->
    <QAutoComplete
      v-if="hasSelection"
      v-model="localValue"
      :label="label"
      :hint="hint"
      :persistentHint="!!hint"
      :list="selectionItems"
      textkey="text"
      valuekey="value"
      :rules="rules"
      :clearable="!definition.IsRequired"
      :multiple="true"
      externaledit
    />
    <QTextField
      v-else
      v-model="csvValue"
      :label="label"
      :hint="csvHint"
      :persistentHint="!!hint"
      :rules="rules"
      :disabled="true"
      :placeholder="`No '${definition.Name}' available`"
    />
  </div>
</template>

<script>
import QAutoComplete from "@/components/Inputs/QAutoComplete.vue";
import QTextField from "@/components/Inputs/QTextField.vue";

export default {
  name: "QAIFieldStringListMultiple",
  components: { QAutoComplete, QTextField },
  props: {
    value: { type: [Array, String], default: () => [] },
    definition: { type: Object, required: true },
  },
  computed: {
    hasSelection() {
      return this.definition.Selection && Object.keys(this.definition.Selection).length > 0;
    },
    selectionItems() {
      if (!this.definition.Selection) return [];
      return Object.entries(this.definition.Selection).map(([key, val]) => ({
        value: key,
        text: val,
      }));
    },
    localValue: {
      get() {
        if (Array.isArray(this.value)) return this.value;
        if (this.value) return [this.value];
        return [];
      },
      set(v) {
        this.$emit("input", v || []);
      },
    },
    csvValue: {
      get() {
        if (Array.isArray(this.value)) return this.value.join(", ");
        return this.value || "";
      },
      set(v) {
        if (!v) {
          this.$emit("input", []);
          return;
        }
        this.$emit("input", v.split(",").map(s => s.trim()).filter(Boolean));
      },
    },
    label() {
      return this.definition.Description || this.definition.Name;
    },
    hint() {
      return this.definition.DefaultValue ? `Default: ${this.definition.DefaultValue}` : "";
    },
    csvHint() {
      const base = this.definition.DefaultValue ? `Default: ${this.definition.DefaultValue}` : "";
      return base ? `${base} (comma-separated)` : "Comma-separated values";
    },
    rules() {
      return this.definition.IsRequired
        ? [v => (Array.isArray(v) ? v.length > 0 : !!v) || `${this.definition.Name} is required`]
        : [];
    },
  },
};
</script>
